import { render, staticRenderFns } from "./Filials-registration.vue?vue&type=template&id=27151dbf&"
import script from "./Filials-registration.vue?vue&type=script&lang=js&"
export * from "./Filials-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports